var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVentoryWhiteNoBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}.cls-2{fill:#00f28d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.26,72l29.87,72h-13.8L289.56,72Zm58.82,0-20.61,49.75h-13.7L348.38,72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M451,84.36H406.24v47.18H451V144H393V72h58Zm-36.06,29.87,4.23-12.46h24.1v12.46Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M553.21,144H537.75L499.54,96.31V144H486.25V72h9.17Zm-14.74-23.79V72h13.29v48.21Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M580.62,84.36V72h63.67V84.36ZM605.86,97l13.19-4.53V144H605.86Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M666.22,101.77A37.43,37.43,0,0,1,679,79.1a38,38,0,0,1,49.24,0,37.07,37.07,0,0,1,12.87,22.67l-13.08,2a23.45,23.45,0,0,0-8.45-14.62,24.65,24.65,0,0,0-31.93,0,23.32,23.32,0,0,0-8.35,14.62Zm74.89,12.46a37,37,0,0,1-12.87,22.66,37.95,37.95,0,0,1-49.24,0,37.38,37.38,0,0,1-12.78-22.66l13.08-2.06a23.34,23.34,0,0,0,8.35,14.63,24.65,24.65,0,0,0,31.93,0A23.48,23.48,0,0,0,728,112.17Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M785.5,85.18V144H772.21V72l37.91-.11a24.28,24.28,0,0,1,17.72,7.32,23.74,23.74,0,0,1,7.41,17.61,22.5,22.5,0,0,1-4.84,14.12,24,24,0,0,1-12.57,8.55l21,24.51H822.38l-28.54-33.37H804c10.72,0,17.93-5.57,17.93-13.81a11,11,0,0,0-3.51-8.24,11.34,11.34,0,0,0-8.34-3.4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M870.72,72l27.4,40.69V144H884.83V115.37L855.58,72Zm56.76,0-19.06,28.12H893.28L912.34,72Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86,97.13a60.08,60.08,0,0,1,118.17,0l11.72-2.23a72,72,0,0,0-141.62,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.12,118.87a60.08,60.08,0,0,1-118.17,0L74.22,121.1a72,72,0,0,0,141.62,0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.47,77.78l29.88,72H138.54l-29.77-72Zm58.82,0-20.6,49.75H147l20.6-49.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentoryWhiteNoBack);
export default __webpack_public_path__ + "static/media/Ventory-WhiteNoBack.35a63212148186856c32e8759118d46a.svg";
export { ForwardRef as ReactComponent };